/**
 * Unscheduled Task Tray — drag (desktop) or tap-select (mobile) to place onto the grid.
 */
import React from 'react';
import { Badge } from '../ui/badge';
import { GripVertical } from 'lucide-react';

export function TaskTray({ tasks, selectedTaskId, onSelect }) {
  return (
    <div className="space-y-2" data-testid="unscheduled-task-tray">
      <p className="text-xs font-semibold text-muted-foreground uppercase tracking-wide">Unscheduled Tasks ({tasks.length})</p>
      {tasks.length === 0 ? (
        <p className="text-xs text-muted-foreground py-4 text-center">Everything is scheduled 🎉</p>
      ) : (
        <div className="flex flex-row md:flex-col gap-2 overflow-x-auto md:overflow-visible pb-2">
          {tasks.map((t) => (
            <div
              key={t.id}
              draggable
              onDragStart={(e) => e.dataTransfer.setData('application/json', JSON.stringify({ type: 'task', id: t.id }))}
              onClick={() => onSelect(t.id === selectedTaskId ? null : t.id)}
              data-testid={`tray-task-${t.id}`}
              className={`shrink-0 md:w-full min-w-[180px] flex items-center gap-2 rounded-lg border p-2.5 cursor-grab active:cursor-grabbing transition-colors ${
                selectedTaskId === t.id ? 'border-primary bg-primary/10 ring-1 ring-primary' : 'border-border bg-card hover:border-primary/40'
              }`}
            >
              <GripVertical className="h-3.5 w-3.5 text-muted-foreground shrink-0" />
              <div className="min-w-0">
                <p className="text-xs font-medium truncate">{t.title}</p>
                {t.subject_name && <p className="text-[10px] text-muted-foreground truncate">{t.subject_name}</p>}
              </div>
              <Badge variant="outline" className="ml-auto text-[9px] px-1 shrink-0">{t.priority}</Badge>
            </div>
          ))}
        </div>
      )}
      {selectedTaskId && (
        <p className="text-[11px] text-primary font-medium" data-testid="tray-selected-hint">
          Task selected — tap a time slot on the grid to place it.
        </p>
      )}
    </div>
  );
}
